import { StatusTag } from '../../../components/StatusTag';
import { useT } from '../../../locales';
import type { CobroClienteResponse } from '@aid/shared';
import {
  getFacturaStatusKey,
  getFacturaStatusLabel,
  getFacturaStatusTone,
} from '../lib/factura-table-helpers';

export function FacturaStatusTag({ factura }: { factura: CobroClienteResponse }) {
  const t = useT();
  const statusKey = getFacturaStatusKey(factura);
  return (
    <StatusTag tone={getFacturaStatusTone(statusKey)}>
      {getFacturaStatusLabel(statusKey, t)}
    </StatusTag>
  );
}
